import { tap, mergeMap } from "rxjs/operators";
import { formOperation } from "../../wrappers/formOperation";
import { TActionsDefinitionsList } from "./TAction";
import { routeAction } from "./actionFunctions";

export const actions: TActionsDefinitionsList = [
    routeAction("VIEW_CRM_LISTINGS_PROFIT_REPORT", (obs$, lens, setState, getState) => {
        obs$.pipe(
            tap(() => setState(lens.listings_profit_report_page.report.status.set("loading"))),
            mergeMap(() =>
                formOperation("GetListingsProfitReport", lens.listings_profit_report_page.report.get()(getState())),
            ),
            tap((response) => setState(lens.listings_profit_report_page.report.set(response))),
        ).subscribe();
    }),
];
